'use client';

import { NAVBAR_Z_INDEX } from '@/lib/utils';
import { Loader } from '@mantine/core';
import clsx from 'clsx';

export function SuspenseLoader() {
  return (
    <div className={clsx('fixed inset-0 bg-white justify-center items-center', `z-[${NAVBAR_Z_INDEX * 2}]`)}>
      <Loader size="lg" />
    </div>
  );
}
